import { render, staticRenderFns } from "./PollResultsPercentage.vue?vue&type=template&id=1552de22&scoped=true"
import script from "./PollResultsPercentage.vue?vue&type=script&lang=js"
export * from "./PollResultsPercentage.vue?vue&type=script&lang=js"
import style0 from "./PollResultsPercentage.vue?vue&type=style&index=0&id=1552de22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1552de22",
  null
  
)

export default component.exports